<app-attendee-banner
  [banner]="banner"
  [isHp]="isHp"
  class="container lg:mb-4xs px-4xs lg:pt-6xl lg:px-7xl font-inter font-medium"
></app-attendee-banner>
